const VARIABLES = [
  { token: "{{participant_name}}", meaning: "the selected act's display name" },
  { token: "{{participant_color}}", meaning: "its hex colour" },
  { token: "{{scene_name}}", meaning: "the chosen vibe's name" },
  { token: "{{event_name}}", meaning: "this event's name" },
];

/** Documents the interpolation tokens the Rails PromptInterpolator supports. */
export function PromptHelp() {
  return (
    <details className="rounded-lg border border-ink-600 bg-ink-800/60 px-4 py-3 text-xs">
      <summary className="cursor-pointer select-none text-haze-300 hover:text-haze-100">
        Available prompt variables
      </summary>
      <ul className="mt-3 flex flex-col gap-1.5">
        {VARIABLES.map((variable) => (
          <li key={variable.token} className="flex flex-wrap items-center gap-2 text-haze-400">
            <code className="rounded bg-ink-900 px-1.5 py-0.5 text-accent">{variable.token}</code>
            <span>{variable.meaning}</span>
          </li>
        ))}
      </ul>
    </details>
  );
}
